import { ShieldAirplaneOutlineIcon } from './ShieldAirplaneOutlineIcon';

/**
 * author: Michael Irigoyen
 * id C14BAFFB-948A-45C3-ABFD-4F6215318D65
 * name shield-airplane-outline
 * version: 3.2.89
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shield-airplane-outline.svg
 * tags
 * - Transportation + Flying 
 */
export const ShieldPlaneOutlineIcon = ShieldAirplaneOutlineIcon;
export default ShieldPlaneOutlineIcon